"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserClient = void 0;
const BaseClient_1 = require("../BaseClient");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class UserClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    async getUserState() {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/user/state',
        });
        return response.data;
    }
    async invalidateUserState() {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/user/invalidate-state',
        });
        return response.data;
    }
    async logout() {
        await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/user/logout',
        });
    }
    async switchUser(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/user/switch',
            data: request,
        });
        return response.data;
    }
    async switchBackUser() {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/user/switch-back',
        });
        return response.data;
    }
    async renewSession() {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/user/renewSession',
        });
        return response.data;
    }
}
exports.UserClient = UserClient;
